.ux-select__wrapper {
  display: inline-block;

  &--full-width {
    max-width: 100%;
    width: 100%;
  }

  &__inner {
    background: var(--ux-input-background-color);
  }

  // this is used for styling the placeholder text (inside <option disabled>)
  // this style is applied if an option with an empty value is selected and the select is required
  select:invalid {
    color: var(--ux-input-placeholder-color, #a9a9a9) !important;
  }
}
